import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47772bbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_2 = { class: "page-default page-media" }
const _hoisted_3 = { class: "path-links" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_5 = { class: "header" }
const _hoisted_6 = { class: "album" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "details" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "16",
    width: "14",
    height: "2"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "11",
    width: "14",
    height: "2"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "6",
    width: "14",
    height: "2"
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick", "title"]
const _hoisted_12 = { class: "body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "inLanguage",
  content: "zh-CN"
}, null, -1))
const _hoisted_14 = { itemprop: "name" }
const _hoisted_15 = {
  key: 0,
  class: "toolbar"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-yinliang" }, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("播放音频")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  class: "content",
  itemprop: "articleBody"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "footer" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))

import backMusic, { State as MusicState } from '@/store/backMusic';
import book, { State } from '@/store/gospel/book';
import i18, { State as I18State } from '@/store/i18';
import { datetime } from '@/views/filters';
import { computed, ref } from "vue";
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const bookState = computed<State>(() => store.state[book.name])

const currIndex = computed(() => bookState.value.book.articles.findIndex(item => item.id == bookState.value.article.id))
const asideActive = ref(false)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].gospel)
const langCommon = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].common)

function goHome() {
    router.push({
        name: 'gospel'
    })
}

function goCategory(id: number) {
    router.push({
        name: 'gospel/categories',
        params: {
            id
        }
    })
}

function onArticle(id: number) {
    asideActive.value = false
    router.push({
        name: 'gospel/view',
        params: {
            id: bookState.value.book.id
        },
        query: {
            aid: id
        }
    })
}

function onPrev() {
    if (currIndex.value > 0) {
        let item = bookState.value.book.articles[currIndex.value - 1]
        onArticle(item.id)
    }
}

function onNext() {
    if (currIndex.value < bookState.value.book.articles.length - 1) {
        let item = bookState.value.book.articles[currIndex.value + 1]
        onArticle(item.id)
    }
}

function onPlayAudio(url: string) {
    backMusic.playAudio(store, {
        url,
        title: bookState.value.article.title,
        cover: bookState.value.book.thumb
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "link line",
          onClick: goHome
        }, _toDisplayString(_unref(lang).gospel), 1),
        _hoisted_4,
        _createElementVNode("a", {
          class: "link line",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goCategory(_unref(bookState).book.category.id)))
        }, _toDisplayString(_unref(bookState).book.category.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: _unref(bookState).book.thumb
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(_unref(bookState).book.title), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(_unref(lang).author) + "：" + _toDisplayString(_unref(bookState).book.author), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).updateTime) + "：" + _toDisplayString(_unref(datetime)(_unref(bookState).book.updatetime)), 1)
          ])
        ])
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("aside", {
          class: _normalizeClass(asideActive.value ? 'active' : null)
        }, [
          _createElementVNode("div", {
            class: "toggle",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (asideActive.value = !asideActive.value))
          }, _hoisted_10),
          _createElementVNode("h3", null, _toDisplayString(_unref(lang).contents), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookState).book.articles, (item) => {
              return (_openBlock(), _createElementBlock("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(_unref(bookState).article.id == item.id ? 'active' : null),
                  onClick: ($event: any) => (onArticle(item.id)),
                  title: item.title
                }, _toDisplayString(item.title), 11, _hoisted_11)
              ]))
            }), 256))
          ])
        ], 2),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(bookState).article.title), 1),
          (_unref(bookState).article.audio_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("a", {
                  class: "link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onPlayAudio(_unref(bookState).article.audio_url)))
                }, _hoisted_18)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                innerHTML: _unref(bookState).article.content
              }, null, 8, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", {
                onClick: onPrev,
                class: _normalizeClass(["prev", { disabled: _unref(currIndex) <= 0 }])
              }, [
                _hoisted_22,
                _createTextVNode(" " + _toDisplayString(_unref(langCommon).prev_page), 1)
              ], 2),
              _createElementVNode("a", {
                onClick: onNext,
                class: _normalizeClass({ disabled: _unref(currIndex) >= _unref(bookState).book.articles.length - 1 })
              }, [
                _createTextVNode(_toDisplayString(_unref(langCommon).next_page) + " ", 1),
                _hoisted_23
              ], 2)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})